import {
  CheckoutAdventureForm,
  CheckoutTotalPrice,
  CheckoutAdventureLoader,
  CheckoutFinalStep,
} from '../components/checkout-adventures'
import { connect } from 'react-redux'
import { parseQuery } from '../utils'
import { useMemo, useState, useEffect, Fragment } from 'react'
import isArray from 'lodash/isArray'
import find from 'lodash/find'
import setQuery from 'set-query-string'
import API from '../api'
import get from 'lodash/get'

import {
  PAYMENT_SUCCEEDED,
  PAYMENT_FAILED,
  PAYMENT_PROCESSING,
} from '../components/checkout-adventures/constants'
import { convertCurrency } from '../components/helpers/PriceConverter'
import { getProductCategory } from '../components/dive-guides/gtm-events'
import { setBrandValue } from '../gtm'
import store2 from 'store2'
import PropTypes from 'prop-types'

function CheckoutAdventurePage({
  activityDateTime,
  activityId,
  selectedCurrency,
  countryCode,
}) {
  const [isLoading, setLoading] = useState(true)
  const [shop, setShopData] = useState({})
  const [extraInfo, setExtraInfo] = useState({})
  const [activity, setActiviyData] = useState({})
  const [addedInclusions, setAddedInclusions] = useState([])
  const [checkoutLastStepData, setLastStepData] = useState(false)
  const [ecommerce, setEcommerce] = useState([])
  const onSubmitSuccess = (data) => {
    data.paymentStatus = PAYMENT_SUCCEEDED
    setLastStepData(data)
  }
  const queries = useMemo(() => {
    return parseQuery()
  })
  const { participants, quantity } = queries

  const guestsNumber = participants || 1

  let extraOptions
  try {
    if(isArray(queries.inclusions)) {
      extraOptions = queries.inclusions.map((inclusion) => {
        const data = inclusion.split(',')
        return {
          extraOptionId: +data[0],
          quantity: +data[1],
        }
      })
    } else if(queries.inclusions) {
      const data = queries.inclusions.split(',')
      extraOptions = [
        {
          extraOptionId: +data[0],
          quantity: +data[1],
        },
      ]
    }
  } catch (e) {
    console.error(e)
  }

  const checkPayment = () => {
    API(
      `/api/adventure/v1/checkout/payment-intent/${queries.payment_intent}/status/`,
    )
      .get()
      .then(({ status }) => {
        if(status === PAYMENT_SUCCEEDED) {
          onSubmitSuccess({
            email: decodeURIComponent(queries.email),
            reference: queries.booking_ref,
          })
          setLoading(false)
          setQuery()
        } else if(status === PAYMENT_FAILED) {
          setLastStepData({ paymentStatus: PAYMENT_FAILED })
          setQuery()
        } else {
          setLastStepData({ paymentStatus: PAYMENT_PROCESSING })
          // Send one more request, to receive new information
          setTimeout(() => {
            checkPayment()
          }, 1000)
        }
      })
      .finally(() => {
        setLoading(false)
      })
  }

  useEffect(() => {
    // wechat pay success
    const { email, reference } = queries
    if(email && reference) {
      const data = {
        email,
        reference,
        paymentStatus: PAYMENT_SUCCEEDED,
      }
      setLastStepData(data)
      setLoading(false)
      return
    }
    if(!queries.payment_intent) {
      API()
        .all([
          API(`/api/adventure/v1/${activityId}/detail/activity/`).get(),
          API(`/api/adventure/v1/${activityId}/detail/shop/`).get(),
          API(
            `/api/adventure/v1/${activityId}/detail/extra-options/info/`,
          ).get(),
        ])
        .then(([activity, shop, extraInfo]) => {
          setActiviyData({
            diveSite: queries['dive_site_id'],
            ...activity,
          })
          setShopData(shop)
          setExtraInfo(extraInfo)
          setLoading(false)
          const { type, checkoutType } = getProductCategory(
            activity.productType,
          )
          window.dataLayer.push({
            business_type: checkoutType,
            business_name: shop.title,
            business_country_slug: shop.countrySlug,
            business_slug: shop.slug,
          })

          let items = []
          const originValue = get(activity, 'minimumPrice.originValue', 0)
          const originCurrency = get(
            activity,
            'minimumPrice.originCurrency',
            '',
          )
          let ga4EcommerceProducts = [
            {
              item_name: activity.titleEn,
              item_id: activity.activityId.toString(),
              price: Number(
                convertCurrency(originValue, originCurrency, 'USD').toFixed(2),
              ),
              item_brand: 'PADI',
              item_category: 'PADI Travel',
              item_category2: type,
              item_category3: `${activity.standardProductName}`,
              item_category4: shop.affiliateId,
              item_category5: '',
              item_variant: '',
              bundle_name: '',
              bundle_id: '',
              item_list_name: 'PADI Travel Adventures - Product Page',
              quantity: Number(guestsNumber),
            },
          ]

          let ecommerceProducts = [
            {
              // TODO: Repalce with English title for all languages
              name: activity.titleEn,
              id: activity.activityId,
              price: convertCurrency(
                originValue,
                originCurrency,
                selectedCurrency,
                false,
                true,
              ).toFixed(2),
              brand: setBrandValue(shop),
              category: type,
              quantity: +guestsNumber,
            },
          ]
          if(extraOptions && activity.notIncludedInPrice) {
            activity.notIncludedInPrice.forEach((item) => {
              extraOptions.forEach((inclusion) => {
                if(inclusion.extraOptionId === item.extraOptionId) {
                  items.push({
                    title: item.title,
                    groupCode: item.groupCode,
                    quantity: inclusion.quantity,
                  })

                  ga4EcommerceProducts.push({
                    item_name: item.titleEn,
                    item_id: item.extraOptionId.toString(),
                    price: Number(
                      convertCurrency(
                        item.price.originValue,
                        item.price.originCurrency,
                        'USD',
                        false,
                        true,
                      ).toFixed(2),
                    ),
                    item_brand: 'PADI',
                    item_category: 'PADI Travel',
                    item_category2: type,
                    item_category3: '',
                    item_category4: shop.id,
                    item_category5: '',
                    item_variant: '',
                    bundle_name: '',
                    bundle_id: '',
                    quantity: Number(inclusion.quantity),
                    item_list_name: 'PADI Travel Adventures - Product Page',
                  })
                  ecommerceProducts.push({
                    name: item.titleEn,
                    id: item.extraOptionId,
                    price: convertCurrency(
                      item.price.originValue,
                      item.price.originCurrency,
                      selectedCurrency,
                      false,
                      true,
                    ).toFixed(2),
                    brand: setBrandValue(shop),
                    category: type,
                    quantity: +inclusion.quantity,
                  })
                }
              })
            })
          }

          setAddedInclusions(items)
          setEcommerce(ecommerceProducts)

          store2.session('ga4Ecommerce', {
            currency: 'USD',
            items: ga4EcommerceProducts,
          })

          /* window.dataLayer.push({
            event: 'checkout',
            currencyCode: selectedCurrency,
            ecommerce: {
              checkout: {
                actionField: { step: 1 },
                products: ecommerceProducts,
              },
            },
          }) */
        })
    } else {
      checkPayment()
      // setQuery()
    }
  }, [])
  const includedTransfer =
    find(addedInclusions, { groupCode: 'transfers' }) ||
    extraInfo.hasIncludedTransfers
  const includedFood =
    find(addedInclusions, { groupCode: 'food-beverage' }) ||
    extraInfo.hasIncludedFoodBeverage
  const includedRental =
    find(addedInclusions, { groupCode: 'rental-equipment' }) ||
    find(addedInclusions, { groupCode: 'other-equipment' }) ||
    extraInfo.hasRental

  if(isLoading) {
    return <CheckoutAdventureLoader />
  }

  const toBePaidOffline = get(activity, 'customerPaymentMethod.value') === 20

  return (
    <div className='checkout-page checkout-adventures'>
      <div className='checkout-wrapper'>
        {checkoutLastStepData ? (
          <CheckoutFinalStep
            checkoutLastStepData={checkoutLastStepData}
            isWidget={queries.widget}
          />
        ) : (
          <Fragment>
            <CheckoutAdventureForm
              participants={+guestsNumber}
              quantity={quantity}
              activityDateTime={activityDateTime}
              activityId={activityId}
              extraInfo={extraInfo}
              activity={activity}
              includedTransfer={includedTransfer}
              includedFood={includedFood}
              includedRental={includedRental}
              onSubmitSuccess={onSubmitSuccess}
              ecommerce={ecommerce}
              extraOptions={extraOptions}
              toBePaidOffline={toBePaidOffline}
              widgetSource={queries?.source}
              countryCode={countryCode}
              shop={shop}
            />
            <CheckoutTotalPrice
              shop={shop}
              activity={activity}
              activityId={activityId}
              activityDateTime={activityDateTime}
              participants={guestsNumber}
              extraOptions={extraOptions}
              inclusions={addedInclusions}
              toBePaidOffline={toBePaidOffline}
            />
          </Fragment>
        )}
      </div>
    </div>
  )
}

export default connect((state) => ({
  selectedCurrency: state.selectedCurrency,
}))(CheckoutAdventurePage)

CheckoutAdventurePage.propTypes = {
  selectedCurrency: PropTypes.string,
  activityDateTime: PropTypes.string,
  activityId: PropTypes.string,
  countryCode: PropTypes.string,
}
